import { gql } from '@apollo/client';

export const FETCH_SIGNED_RECORDS = gql`
  query getSignatures {
    getSignatures {
      _id
      imageUrl
      signedAt
      room {
        name
      }
      user {
        name
      }
      session
      duration
    }
  }
`;

export const FILTER_AND_SEARCH_RECORDS = gql`
  mutation searchAndFilterSignedRecords(
    $searchValue: String
    $searchType: String
    $date: FilterDateInput
    $session: Int
  ) {
    searchAndFilterSignedRecords(
      searchValue: $searchValue
      searchType: $searchType
      date: $date
      session: $session
    ) {
      _id
      imageUrl
      signedAt
      room {
        name
      }
      user {
        name
      }
      session
      duration
    }
  }
`;
